import React from 'react';
import type { FillAppFieldComment } from 'global/fillapp';

// Provided by FillAppSection; consumed only by FillAppField. Null (the default)
// means no comment UI — FillAppSubtab/RepeatingGroup stay comment-agnostic.
export type StudentFillAppCommentsCtx = {
    commentsByQid: Record<string, FillAppFieldComment[]>;
    resolveComment: (commentId: number) => Promise<void>;
};

export const FillAppCommentsContext = React.createContext<StudentFillAppCommentsCtx | null>(null);
